module.exports = __webpack_public_path__ + "static/media/qingming1Bg.9754c7bd.jpg";